import hrpLogo from '../../media/images/HRP_logo_gross.png';

const marketingPartnersData = {
    'hrp': {
        'value': 0,
        'logo': hrpLogo
    }
}

export default marketingPartnersData;